import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { TextField } from '@material-ui/core';
import { get } from 'lodash';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { RefusalDialogWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/styled-components';
import { toast } from 'react-toastify';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import { getExpertReportPayload } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';

export interface RejectionDialogProps {
  intl: IntlShape;
  isRejectionDialogOpen: boolean;
  setIsRejectionDialogOpen: Function;
  requestValidateExpertReport: Function;
  lawyer: string;
  claimId: number;
  claimNumber: string;
  judiciaryProcessId: number;
  expertReport: ExpertReportType;
  expertiseReport: ExpertReportType;
  isAppeal?: boolean;
}

export const RejectionDialog: React.FC<RejectionDialogProps> = (
  props,
): JSX.Element => {
  const [rejectionReason, setRejectionReason] = useState<string>('');

  const handleChangeRejectionReason = (
    event: React.ChangeEvent<{
      value: string;
    }>,
  ) => setRejectionReason(event.target.value);

  const handleValidation = () => {
    const rejectionRequest = getExpertReportPayload(
      props.expertiseReport,
      props.expertReport,
    );
    props.requestValidateExpertReport(
      {
        ...rejectionRequest,
        sagisEvaluations: [],
        status: PROCEDURE_STATUSES.REJECTED,
        isLawyer: false,
        rejectionReason,
        claimNumber: props.claimNumber,
        procedureType: !props.isAppeal
          ? PROCEDURE_TYPES.FIRST_INSTANCE
          : PROCEDURE_TYPES.APPEAL,
        judiciaryProcessId: get(props.expertiseReport, 'judiciaryProcessId'),
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      handleSuccessCallback,
    );
  };

  const handleSuccessCallback = () => {
    toast.success(
      translate(messages.courtManagerRefusalDialogSuccessMessage, props, {
        lawyer: props.lawyer,
      }),
    );
    props.setIsRejectionDialogOpen(false);
    !featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
      pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
  };

  return (
    <RefusalDialogWrapper
      className="refusal-content"
      handleValidate={handleValidation}
      handleClose={() => props.setIsRejectionDialogOpen(false)}
      title={translate(messages.courtManagerRefuseDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerRefusalDialogReasonCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerRefusalDialogReasonValidate,
        props,
      )}
      open={props.isRejectionDialogOpen}
      validateButtonDisabled={!rejectionReason}
    >
      <div className="reason-wrapper">
        <TextField
          id="judgement-on-merits-rejection-reason"
          label={translate(
            messages.courtManagerRefusalDialogReasonLabel,
            props,
          )}
          onChange={handleChangeRejectionReason}
          value={rejectionReason}
          fullWidth
        />
      </div>
    </RefusalDialogWrapper>
  );
};

export default injectIntl(RejectionDialog);
